import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../User/VUser.scss";
import { AppBar, Tab, Tabs } from "@mui/material";
import { tabStyle, tabsStyle } from "../../Style/ManualStyle";
import SystemConfig from "./AppConfig/SystemConfig";
import BackendJobs from "./AppConfig/BackendJobs";
import {
  getAllAppConfig,
  getAllSysConfig,
  getApiUserRoles,
  getSystemProvider,
} from "../../Utils/actions";
import { infoMsg } from "../../Utils/errorMsg/ErrorMsg";
import background from "../../Assets/Images/bgLicense.jpg";
import { useLocation } from "react-router-dom";
import AppConfigPage from "./AppConfig/AppConfigPage";
import DataQuality from "./AppConfig/DataQuality";
import TeamNotify from "./AppConfig/TeamNotify";

const AppConfig = (props) => {
  const [tabsValue, setTabsValue] = useState(0);
  const [checkBackedSet, setCheckBackedSet] = useState(false);
  const [appConfigPagination, setAppConfigPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [pageIndexAppProp, setPageIndexAppProp] = useState(0);
  const [pageSizeAppProp, setPageSizeAppProp] = useState(10);
  const dispatch = useDispatch();
  const location = useLocation();
  const { dataProvider, rigsData, bUnitData } = useSelector(
    (state) => state.data
  );
  const onTabChange = (e, nextValue) => {
    e.preventDefault();
    if (nextValue === 1) {
      dispatch(getAllSysConfig(pageSizeAppProp, pageIndexAppProp));
    } else if (nextValue == 2) {
      dispatch(getAllAppConfig(pageSizeAppProp, pageIndexAppProp));
    }
    setTabsValue(nextValue);
  };

  useEffect(() => {
    if (tabsValue === 1) {
      dispatch(getSystemProvider());
    }
  }, []);

  const setTabs = (tabsIndex) => {
    if (tabsIndex === 1) {
      setCheckBackedSet(true);
    }
    setTabsValue(tabsIndex);
  };

  useEffect(() => {
    dispatch(getAllAppConfig(pageSizeAppProp, pageIndexAppProp));
  }, [pageSizeAppProp, pageIndexAppProp]);

  const setFinish = () => {
    document.location.replace("/veras/#/login");
  };

  useEffect(() => {
    dispatch(getApiUserRoles(sessionStorage.getItem("username")));
  }, []);

  return (
    <div
      style={{
        backgroundColor: "#333333",
        height: "89vh",
        padding: "15px",
        overflow: "hidden",
        border: "none",
      }}
    >
      <div
        className={"d-flex col-sm-12 white_paper before-login"}
        style={{
          backgroundColor: "#333333",
          overflow: "auto",
          borderRadius: "5px",
          padding: "0px",
          height: "100%",
        }}
      >
        <div
          className={"col-sm-12 before-login-header "}
          style={
            {
              /**  marginTop: "25px" */
            }
          }
        >
          <AppBar
            position="relative"
            className=""
            style={{ boxShadow: "none", backgroundColor: "white" }}
          >
            <Tabs
              value={tabsValue}
              onChange={
                location.pathname === "/validForm"
                  ? checkBackedSet
                    ? onTabChange
                    : () => {
                        infoMsg(
                          "Please first you want to save backend jobs",
                          "Backend Jobs"
                        );
                      }
                  : onTabChange
              }
              style={tabsStyle}
            >
              <Tab label="Backend Jobs" style={tabStyle} />
              <Tab label="Data Provider Configuration" style={tabStyle} />
              <Tab label="Application Configuration" style={tabStyle} />
            </Tabs>
          </AppBar>
          {tabsValue === 0 && <BackendJobs setTabs={setTabs} />}
          {/* {tabsValue === 1 && <SystemConfig setTabs={setTabs} />} */}
          {tabsValue === 1 && (
            <DataQuality
              setTabs={setTabs}
              dataProvider={dataProvider}
              rigsData={rigsData}
              bUnitData={bUnitData}
            />
          )}
          {tabsValue === 2 && (
            <AppConfigPage
              setFinish={setFinish}
              appConfigPagination={appConfigPagination}
              setAppConfigPagination={setAppConfigPagination}
              setPageSizeAppProp={setPageSizeAppProp}
              pageSizeAppProp={pageSizeAppProp}
              pageIndexAppProp={pageIndexAppProp}
              setPageIndexAppProp={setPageIndexAppProp}
            />
          )}
          {tabsValue === 3 && (
            <TeamNotify />
          )}
        </div>
      </div>
    </div>
  );
};

export default AppConfig;
